import { useEffect } from "react";
import { useLang } from "@/contexts/LanguageContext";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Products from "@/components/sections/Products";
import Markets from "@/components/sections/Markets";
import QuoteForm from "@/components/sections/QuoteForm";
import ContactForm from "@/components/sections/ContactForm";
import FAQ from "@/components/sections/FAQ";
import Footer from "@/components/sections/Footer";

const Home = () => {
  const { t } = useLang();

  useEffect(() => {
    document.title = t.meta.title;
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute("content", t.meta.description);
  }, [t]);

  return (
    <div className="bg-[#FAFAF8] text-[#1A2421] min-h-screen">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Products />
        <Markets />
        <QuoteForm />
        <ContactForm />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
